export default "__VITE_ASSET__DeHyeMJu__"